import { LitEntity, html } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-placeholder';

class DeviceSerial extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }

    return html`${this.entity.properties.deviceId}`;
  }
}

window.customElements.define('device-serial', DeviceSerial);
